import React, { useState } from "react";

const Settings = ({ rowsPerPage, setRowsPerPage }) => {
  const [isPrintPopupOpen, setIsPrintPopupOpen] = useState(false);
  const [includeHeaders, setIncludeHeaders] = useState(true);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      <h3 className="p-4 text-xl font-normal text-gray-800 mb-4">Settings</h3>
      <div className="p-4 bg-gray-100 rounded-lg shadow-md max-w-xs mx-4">
        <div className="flex items-center justify-between">
          <label htmlFor="rowsPerPage" className="text-sm text-gray-600">
            Rows per page on Deals:
          </label>
          <select
            id="rowsPerPage"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="block w-28 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800"
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
        </div>
 
        <button
          onClick={() => setIsPrintPopupOpen(true)}
          className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700"
          >
          Print Settings
        </button>
        </div>
      
      {isPrintPopupOpen && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h4 className="text-lg font-medium text-gray-800 mb-4">Print Settings</h4>
            <div className="flex items-center justify-between mb-4">
              <label htmlFor="includeHeaders" className="text-sm text-gray-600">
                Include headers on all pages:
              </label>
              <input
                id="includeHeaders"
                type="checkbox"
                checked={includeHeaders}
                onChange={() => setIncludeHeaders(!includeHeaders)}
                className="w-5 h-5"
              />
            </div>
            <div className="flex justify-end gap-2">
              <button
                onClick={() => setIsPrintPopupOpen(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg shadow-md hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => setIsPrintPopupOpen(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
